import { useEffect, useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { CustomInput } from '../../../../components/form/inputs/Input';
import { Button, Icon, Input, Radio } from 'semantic-ui-react';
import { CustomDropdown } from '../../../../components/form';
import plusOutline from '../../../../assets/add-icon-white-bg.svg';
import { useDispatch, useSelector } from 'react-redux';
import { getOutputFormatTypes } from '../../../../store/actions';
import { isEmpty } from 'lodash';

export const OutputFormatForm = ({
  outputFormat,
  postOutputFormat,
  updateOutputFormat,
  toggle,
  pageChange,
  outLoading,
  isEdit,
  form,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isFormula, setIsFormula] = useState(
    outputFormat ? outputFormat.isFormula : false
  );

  const [formatOptions, setFormatOptions] = useState(
    !isEdit
      ? [
          {
            key: 1,
            name: '',
          },
        ]
      : []
  );

  const [formatOptionsLength, setFormatOptionsLength] = useState(
    !isEdit ? 1 : 0
  );

  const [selectedValue, setSelectedValue] = useState(false);
  const outputFormatTypes = useSelector(
    (state) => state.admin.outputFormatTypes
  );

  useEffect(() => {
    if (outputFormat) {
      setIsFormula(outputFormat.isFormula);
    }
  }, [outputFormat]);

  useEffect(() => {
    if (outputFormat) {
      const options = outputFormat.formatOptions.map((item, key) => {
        return {
          key,
          id: item.id,
          name: item.name,
        };
      });
      setFormatOptions(
        !isEdit
          ? [
              {
                key: 1,
                name: '',
              },
            ]
          : isEmpty(options)
            ? [
                {
                  key: 1,
                  name: '',
                },
              ]
            : options
      );
    }
    if (outputFormatTypes && outputFormat) {
      const dropdownValue = outputFormatTypes.find(
        (item) => item.id === outputFormat.typeId && item.isMultiOption === true
      );
      if (dropdownValue) {
        setSelectedValue(true);
      }
    }
  }, [isEdit, outputFormat, outputFormatTypes]);

  useEffect(() => {
    dispatch(getOutputFormatTypes());
  }, [dispatch]);

  const handleValidSubmit = async (values) => {
    const payload = {
      name: values.name,
      typeId: values.typeId.toString(),
      label: values.label,
      isFormula: isFormula,
      formatOptions: formatOptions.filter((item) => item.name !== ''),
    };

    if (isEdit) {
      await updateOutputFormat(outputFormat.id, payload);
    } else {
      await postOutputFormat(payload);
    }

    toggle();
    pageChange(1);
  };

  const onChangeMultiOption = (e) => {
    const selectedType = outputFormatTypes.find(
      (item) => item.id === parseInt(e.target.value)
    );
    if (selectedType && selectedType.isMultiOption === true) {
      setSelectedValue(true);
    } else {
      setSelectedValue(false);
      setFormatOptions([
        {
          key: 1,
          name: '',
        },
      ]);
      setFormatOptionsLength(1);
    }
  };

  const handleAddNewSubOption = () => {
    const newKey = formatOptionsLength + 1;
    setFormatOptionsLength(newKey);
    setFormatOptions([
      ...formatOptions,
      {
        key: newKey,
        name: '',
      },
    ]);
  };

  const onDeleteOption = (key) => {
    const newFormatOptions = formatOptions.filter((item) => item.key !== key);
    setFormatOptions(newFormatOptions);
    setFormatOptionsLength(formatOptionsLength - 1);
  };

  const onChangeOptions = (data, key) => {
    const newFormatOptions = formatOptions.map((item) => {
      if (item.key === key) {
        return { ...item, name: data };
      }
      return item;
    });
    setFormatOptions(newFormatOptions);
  };

  const deletingArrLength = formatOptions.filter(
    (item) => item.name !== ''
  ).length;

  const renderTypes = outputFormatTypes.map((item) => ({
    key: item.id,
    text: item.name,
    value: item.id,
  }));

  const initialValues = {
    label: outputFormat ? outputFormat.label : '',
    name: outputFormat ? outputFormat.name : '',
    typeId: outputFormat ? outputFormat.typeId : '',
  };

  const validationSchema = Yup.object().shape({
    label: Yup.string().required(
      t('admin.activity_settings.output_formatters.label_required')
    ),
    name: Yup.string().required(
      t('admin.activity_settings.output_formatters.field_name_required')
    ),
    typeId: Yup.string().required(
      t('admin.activity_settings.output_formatters.type_required')
    ),
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => handleValidSubmit(values)}
    >
      {({ handleSubmit, isSubmitting, setFieldValue, errors }) => (
        <Form className="venue-form" onSubmit={handleSubmit}>
          <CustomInput
            labelText={t(
              'admin.activity_settings.output_formatters.label_name'
            )}
            name="label"
            type="text"
            placeholder={t(
              'admin.activity_settings.output_formatters.label_name'
            )}
          />
          <CustomInput
            labelText={t(
              'admin.activity_settings.output_formatters.field_name'
            )}
            name="name"
            type="text"
            placeholder={t(
              'admin.activity_settings.output_formatters.field_name'
            )}
          />
          <CustomDropdown
            labelText={t('common.type')}
            name="typeId"
            id="type"
            getValue={(e) => onChangeMultiOption(e)}
            options={renderTypes}
            placeholder={t('formulary.placeholder.select_type')}
          />
          {selectedValue ? (
            <>
              {isEdit ? (
                <div>
                  <label>
                    {t(
                      'admin.activity_settings.output_formatters.checkbox_names'
                    )}
                  </label>
                </div>
              ) : (
                <div>
                  <label>
                    {t(
                      'admin.activity_settings.output_formatters.checkbox_options'
                    )}
                  </label>
                </div>
              )}
              {formatOptions.map((item, index) => {
                const key = `formatOptions${item.key}`;
                const isExist = item.id > 0 ? true : false;
                return (
                  <div className="d-flex add-venue-sub-label" key={key}>
                    {isEdit ? (
                      <div className="sub-options-container">
                        <Input
                          id={`formatOptions${item.key}`}
                          name={`formatOptions${item.key}`}
                          className="edit-venue-type-input"
                          placeholder=""
                          onChange={(e) =>
                            onChangeOptions(e.target.value, item.key)
                          }
                          value={item.name}
                          icon={
                            !isExist && deletingArrLength > 0 ? (
                              <div className="delete-btn">
                                <Icon
                                  onClick={() => onDeleteOption(item.key)}
                                  name="trash"
                                />
                              </div>
                            ) : null
                          }
                        />
                      </div>
                    ) : (
                      <CustomInput
                        id={`formatOptions${item.key}`}
                        name={`formatOptions${item.key}`}
                        placeholder=""
                        getValue={(e) => onChangeOptions(e, item.key)}
                        icon={
                          index !== 0 && deletingArrLength > 1 ? (
                            <div className="delete-btn">
                              <Icon
                                onClick={() => onDeleteOption(item.key)}
                                name="trash"
                              />
                            </div>
                          ) : null
                        }
                      />
                    )}
                  </div>
                );
              })}
              <div className="d-flex align-items-end flex-column">
                <div>
                  <Button
                    onClick={handleAddNewSubOption}
                    className="btn-add-ref"
                    type="button"
                  >
                    <span>
                      <img className="plus-icon" alt="plus" src={plusOutline} />
                      {t('specific_actions.add_more_options')}
                    </span>
                  </Button>
                </div>
              </div>
            </>
          ) : null}

          <div className="activate-notify-row">
            <div className="evaluation-activity-toggel-group mt-4">
              <label className="lbl-margin-left mb-0">
                {t('admin.activity_settings.output_formatters.include_formula')}
              </label>
              <Radio
                toggle
                name="isFormula"
                type="checkbox"
                checked={isFormula}
                onChange={() => setIsFormula(!isFormula)}
              />
            </div>
          </div>

          <div className="model-button mt-5">
            <Button
              content={t('actions.save')}
              type="submit"
              className="modal-proceed"
              loading={isSubmitting}
              disabled={isSubmitting}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};
